import { render, staticRenderFns } from "./returnTop.vue?vue&type=template&id=20703400&scoped=true"
import script from "./returnTop.vue?vue&type=script&lang=js"
export * from "./returnTop.vue?vue&type=script&lang=js"
import style0 from "./returnTop.vue?vue&type=style&index=0&id=20703400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20703400",
  null
  
)

export default component.exports